import * as z from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

export const useFormWithSchema = <T extends z.ZodSchema<any>>(
  schema: T,
  onSubmit: (data: z.infer<T>) => void,
  defaultValues?: z.infer<T>
) => {
  const methods = useForm<z.infer<T>>({
    resolver: zodResolver(schema),
    defaultValues,
  });

  return { ...methods, onSubmitHandler: methods.handleSubmit(onSubmit) };
};
